export default __webpack_public_path__ + "static/media/cz7.a8584afe.svg";